import { Dispatch, SetStateAction } from 'react'
import { TablePaginationConfig } from 'antd/lib/table'

import { RoutesFilters } from '@types'

interface FiltersContextType {
  filters?: RoutesFilters
  setFilters: Dispatch<SetStateAction<RoutesFilters>>
}

const useRoutesPagination = ({ filters, setFilters }: FiltersContextType, total?: number) =>
  ({
    total,
    pageSize: filters?.limit,
    current: filters?.page || 1,
    position: ['bottomCenter'],
    size: 'small',
    showSizeChanger: false,
    showQuickJumper: false,
    onChange: page => setFilters(prev => ({ ...prev, page })),
  } as TablePaginationConfig)

export { useRoutesPagination }
